<template src="./template.html"></template>
<script>
import Vue from 'vue'
import moment from 'moment'
import _isNumber from 'lodash/isNumber'

import AddAdmissionGroup from 'components/AddAdmissionGroup'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import dateUtils from 'utils/dateUtils'

export default {
  name: 'add-admission-group-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    let theme = this.$route.query.theme
    let hideGuestCount = false
    let shouldLockDate = false

    //TODO: should eventually get the venue to update their code
    //
    if (this.$route.query.client !== 'web') {
      //ignore on the Tablelist website
      if (this.$route.query.venueId === '1ec1e43eb02c59ad') {
        //NOTE: hardcode Holy Cow to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '60d086c11cf0da69') {
        //NOTE: hardcode Grand SF to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === 'efd85112c8b8df9b') {
        //NOTE: hardcode Origin SF to fix their widget colors
        theme = 'theme-dark'
      }
      if (this.$route.query.venueId === '694a66dd8b5fcab5') {
        //NOTE: hardcode Annex Detroit to fix their widget colors
        theme = 'theme-light'
      }
      if (this.$route.query.venueId === 'af570dc9775899fb') {
        //NOTE: hardcode Bodega Canal to fix their widget colors
        theme = 'theme-dark'
      }
    }

    if (this.$route.query.date) {
      let date

      if (moment(this.$route.query.date, moment.ISO_8601, true).isValid()) {
        date = moment.utc(this.$route.query.date, moment.ISO_8601)
      } else {
        const dateNum = parseInt(this.$route.query.date, 10)

        if (_isNumber(dateNum)) {
          date = moment.utc(parseInt(this.$route.query.date, 10), 'x')
        } else {
          date = moment.utc(this.$route.query.date)
        }
      }

      if (date.isValid()) {
        date = dateUtils.toUTCMomentWithoutTime(date)

        this.$store.dispatch('setCurrentDate', date)

        shouldLockDate = true
      }
    }

    //TODO: don't hardcode - have the venue update their widget
    if (this.$route.query.venueId === 'b574e0b6ba6753f5') {
      //Charmaines
      hideGuestCount = true
    }

    return {
      loading: true,
      attributionId: this.$route.query.attributionId,
      type: this.$route.query.type,
      buttonBgColor: this.$route.query.buttonBgColor,
      buttonTextColor: this.$route.query.buttonTextColor,
      buttonText: this.$route.query.buttonText,
      hideGuestCount,
      shouldLockDate,
      theme,
    }
  },
  methods: {
    onAdmissionGroupCreated(result) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.ADMISSION_GROUP_CREATED,
          iframeId: this.iframeId,
          data: {
            admissionGroup: result,
          },
        },
        {
          parent: true,
        }
      )
    },
    onDatepickerOpened() {
      Vue.nextTick(() => {
        this.publishDimensions()
      })
    },
    onUpdated() {
      this.publishDimensions()
    },
  },
  components: {
    AddAdmissionGroup,
  },
  created() {
    this.loading = true

    const promises = [this.$store.dispatch('getVenue', this.$route.query.venueId)]

    if (this.attributionId) {
      promises.push(this.$store.dispatch('setConfigAttributionId', this.attributionId))
    }

    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/AddAdmissionGroup/index.vue